import { AccessSettingsService } from './service/access-settings.service';
import { Component, OnInit } from '@angular/core';
import { faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';

export interface AllGroups {
	permission?: string;
	distinguishedName?: string;
	usertype?: string;
	description?: string;
	customer?: number;
	full_name?: string;
	email?: string;
	selected?: boolean;
	sort_order?: number;
	group?: number;
	toggle?: boolean;
}
@Component({
	selector: 'register-form-access-settings',
	templateUrl: './access-settings.component.html',
	styleUrls: ['./access-settings.component.scss'],
})
export class AccessSettingsComponent implements OnInit {
	icons = {
		faToggleOn: faToggleOn,
		faToggleOff: faToggleOff,
	};

	selectedUsertype = '';
	selectedPermission: string[] = [];
	selectedGroup = '';
	searchText: string;
	searchTextPermissions: string;
	searchPermissions: string;
	usertypeValue = '';

	showTableEnduser = false;
	showTableGroup = false;
	isLoadingData = true;
	showView = false;

	isLoadingPermissionData = true;
	isLoadingLabels = true;

	labels: any = {
		lbl_geral_salvar: 'Save',
		lbl_geral_selecione: 'Select',
		lbl_geral_limpar_campos: 'Clear Fields',
		lbl_campos_filtro: 'Fill in the fields marked with * and select a filter',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_geral_excluir: 'Delete',
		lbl_geral_deletado_com_sucesso: 'Successfully deleted',
		lbl_erro_nome_selecionado: 'ERROR: The selected name exists',
		lbl_geral_pesquisar: 'Search',
		lbl_geral_groups_users: 'Groups and Users',
		lbl_geral_groups_ad: 'AD Groups',
		lbl_geral_tipo_usuario: 'Enduser Type',
		lbl_geral_permissoes: 'Access Permissions',
		lbl_geral_sel_grupo: 'Select a Solution Area',
		lbl_geral_grupos: 'Solution Areas',
		lbl_cadastro_permissoes: 'Permissions',
		lbl_geral_search_permissions: 'Search Permissions',
		lbl_geral_nome: 'Name',
		lbl_cmdb_email: 'E-mail',
		lbl_geral_cancelar: 'Cancel',
		lbl_geral_atualizar: 'Update',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_descricao: 'Description',
		lbl_geral_new_permission_group: 'New Permission Group',
		lbl_rep_ordem: 'Presentation Order',
		lbl_erro_0448: 'ERROR: Please fill the field',
	};

	filteredItems: AllGroups[] = [];
	groupsList: AllGroups[] = [];
	groupsSearchList: AllGroups[] = [];
	endusersList: AllGroups[] = [];
	usertypeList: AllGroups[] = [];
	allGroupsList: AllGroups[] = [];
	permissionsList: AllGroups[] = [];
	allListPermissions: AllGroups[] = [];
	searchListPermissions: AllGroups[] = [];

	constructor(
		private AccessSettingsService: AccessSettingsService,
		private notification: NotificationService,
		private labelsService: LabelsService
	) {}

	selectedTab = 'group_permission';

	ngOnInit() {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.AccessSettingsService.getSearchUsertype()
			.subscribe((listUsertype) => {
				this.usertypeList = listUsertype;
			})
			.add(() => {
				this.isLoadingPermissionData = false;
				this.isLoadingData = false;
			});

		this.AccessSettingsService.getSearchPermissions().subscribe((listPermissions) => {
			this.allListPermissions = listPermissions;
			this.permissionsList = listPermissions;
			this.searchListPermissions = [...listPermissions];
		});
	}

	onPermissionChange(): void {
		this.AccessSettingsService.getSearchPermissions(this.selectedUsertype).subscribe((permission) => {
			this.permissionsList = permission;
			for (let index = 0; index <= this.permissionsList.length; index++) {
				if (this.permissionsList[index] && this.permissionsList[index].toggle === true) {
					this.selectedPermission.push(this.permissionsList[index].permission);
				}
			}
		});
	}

	toggleChange(value: string, index: number) {
		if (this.selectedPermission.includes(value)) {
			this.selectedPermission = this.selectedPermission.filter((permission) => permission !== value);
			this.permissionsList[index].toggle = false;
		} else {
			this.selectedPermission.push(value);
			this.permissionsList[index].toggle = true;
		}
	}

	managePermissionGroup(usertype: string, permission: string[]): any {
		if (usertype === '' || permission.length === 0) {
			this.notification.setNotificationMessage(this.labels.lbl_campos_filtro);
		} else {
			const body = [];

			permission.forEach((permissionValue: string) => {
				body.push({
					// usertype: usertype,
					permission: permissionValue,
				});
			});

			const payload = {
				usertype: usertype,
				permissions: body,
			};

			this.AccessSettingsService.managePermissionGroup(payload.usertype, payload.permissions)
				.subscribe((res) => {
					if (res.status === 'Error') {
						this.notification.setNotificationMessage(this.labels.lbl_erro_nome_selecionado);
					} else {
						this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
						this.isLoadingPermissionData = true;
					}
				})
				.add(() => {
					this.isLoadingPermissionData = false;
				});
		}
	}

	saveGroupsUsers() {
		if (this.usertypeValue.trim() === '') {
			return this.notification.setNotificationMessage(this.labels.lbl_erro_0448);
		}
		this.AccessSettingsService.postUsertype(this.usertypeValue)
			.subscribe(() => {
				this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.usertypeValue = '';
				this.loadUsertypeList();
			})
			.add(() => {
				this.isLoadingData = false;
				this.showView = false;
			});
	}

	deleteUsertype(): void {
		if (this.selectedUsertype === '') {
			return this.notification.setNotificationMessage(this.labels.lbl_geral_group_permission);
		}
		this.AccessSettingsService.deleteUsertype(this.selectedUsertype)
			.subscribe(() => {
				this.notification.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
				this.loadUsertypeList();
			})
			.add(() => {
				this.selectedUsertype = '';
				this.showView = false;
			});
	}

	loadUsertypeList() {
		this.AccessSettingsService.getSearchUsertype()
			.subscribe((listUsertype) => {
				this.usertypeList = listUsertype;
			})
			.add(() => {
				this.isLoadingData = false;
			});
	}

	searchPermissionsAll() {
		const selectedPermissions = new Set(this.selectedPermission);

		this.permissionsList =
			this.searchPermissions === ''
				? [...this.allListPermissions]
				: this.allListPermissions.filter((item) => {
						return (
							item.permission.toLowerCase().includes(this.searchPermissions.toLowerCase()) ||
							item.description.toLowerCase().includes(this.searchPermissions.toLowerCase()) ||
							item.group.toString().toLowerCase().includes(this.searchPermissions.toLowerCase())
						);
					});

		for (let index = 0; index < this.permissionsList.length; index++) {
			const permission = this.permissionsList[index].permission;
			this.permissionsList[index].toggle = selectedPermissions.has(permission) ? true : false;
		}
	}

	showViewDiv(): void {
		this.showView = !this.showView;
	}
}
